import { render, staticRenderFns } from "./ProductFilesTable.vue?vue&type=template&id=17e5c9e5"
import script from "./ProductFilesTable.vue?vue&type=script&lang=js"
export * from "./ProductFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports